import React from 'react';
import { ShieldCheck } from 'lucide-react';

const SecurityWizard = ({ data, setData }) => {
  const options = [
    { id: 'encapsulate', label: 'Encapsular en Método',      desc: 'Mover el check a un método/subrutina reutilizable' },
    { id: 'handleError', label: 'Gestión de Error',          desc: 'Mensaje de error y manejo de excepción' },
    { id: 'addLogging',  label: 'Log de Auditoría (BALW)',   desc: 'Registro de accesos y violaciones de seguridad' },
    { id: 'multiLevel',  label: 'Verificación Multi-Nivel',  desc: 'Chequeo en múltiples niveles de la aplicación' },
  ];

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left space-y-6">

      {/* NOTA */}
      <div className="bg-amber-900/10 border-l-4 border-amber-600 p-5 rounded-r-3xl flex gap-4 items-start">
        <div className="bg-amber-600 p-2 rounded-xl text-white shrink-0">
          <ShieldCheck size={18} />
        </div>
        <div>
          <p className="text-[11px] text-amber-400 font-black uppercase tracking-widest mb-1">
            Authorization Check Guide
          </p>
          <p className="text-[11px] text-slate-400 leading-relaxed">
            Ingresá el objeto de autorización SAP y las actividades a verificar. 
            El motor genera el <strong>AUTHORITY-CHECK</strong> completo con manejo de errores, 
            log de auditoría y las mejores prácticas de seguridad para S/4HANA.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        {/* COLUMNA 1 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-amber-500 space-y-4">
          <label className="text-[10px] font-black text-amber-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <ShieldCheck size={14}/> Configuración de Seguridad
          </label>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Objeto de Autorización
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs font-mono text-amber-300 placeholder:text-slate-600 outline-none focus:border-amber-400 uppercase"
              placeholder="Ej: S_CARRID o Z_SALES_ORG"
              value={data.authObject || ''}
              onChange={(e) => setData({...data, authObject: e.target.value})}
            />
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Actividad (ACTVT)
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs font-mono text-white placeholder:text-slate-600 outline-none focus:border-amber-400"
              placeholder="Ej: 01 (Create), 03 (Display)"
              value={data.authActivity || ''}
              onChange={(e) => setData({...data, authActivity: e.target.value})}
            />
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Módulo SAP
            </label>
            <select
              className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-amber-500"
              value={data.authModule || 'SD'}
              onChange={(e) => setData({...data, authModule: e.target.value})}
            >
              <option value="SD">SD — Ventas y Distribución</option>
              <option value="MM">MM — Gestión de Materiales</option>
              <option value="FI">FI — Finanzas</option>
              <option value="CO">CO — Controlling</option>
              <option value="PP">PP — Producción</option>
              <option value="HR">HR — Recursos Humanos</option>
              <option value="BASIS">BASIS — Administración SAP</option>
            </select>
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Campo de Autorización (FIELD)
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs font-mono text-white placeholder:text-slate-600 outline-none focus:border-amber-400 uppercase"
              placeholder="Ej: VKORG, BUKRS, WERKS"
              value={data.authField || ''}
              onChange={(e) => setData({...data, authField: e.target.value})}
            />
          </div>
        </div>

        {/* COLUMNA 2 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-amber-500 space-y-4">
          <label className="text-[10px] font-black text-amber-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <ShieldCheck size={14}/> Opciones de Seguridad
          </label>

          <div className="space-y-3">
            {options.map((opt) => (
              <button
                key={opt.id}
                onClick={() => setData({
                  ...data,
                  securityOpts: { ...data.securityOpts, [opt.id]: !data.securityOpts?.[opt.id] }
                })}
                className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-all text-left ${
                  data.securityOpts?.[opt.id]
                    ? 'bg-amber-600/20 border-amber-500/50'
                    : 'bg-slate-800 border-slate-700 hover:border-slate-600'
                }`}
              >
                <div className={`w-2 h-2 rounded-full shrink-0 ${data.securityOpts?.[opt.id] ? 'bg-amber-400 animate-pulse' : 'bg-slate-600'}`} />
                <div className="flex-1">
                  <p className={`text-[10px] font-black uppercase ${data.securityOpts?.[opt.id] ? 'text-amber-400' : 'text-slate-400'}`}>
                    {opt.label}
                  </p>
                  <p className="text-[9px] text-slate-500">{opt.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityWizard;